import { useDispatch, useSelector } from "react-redux"
import { getPartnerFirstName, getPartnerLastName } from "../../../../reducers/userInfo"
import { updatePartnerName } from "../../../../actions/userActions"
import { useForm } from "react-hook-form"
import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import { FleLinkWrapper } from "../../atoms/Links"
import React from "react"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { TopSection } from "../TopSection"

const AboutYourPartnerName = ({ next, history }) => {
  const { partnerFirstName, partnerLastName } = useSelector((state) => ({
    partnerFirstName: getPartnerFirstName(state),
    partnerLastName: getPartnerLastName(state)
  }))
  const dispatch = useDispatch()

  const submitPartnerName = async (data) => {
    await dispatch(updatePartnerName(data), null)
    history.push(next)
  }

  const { register, handleSubmit, errors } = useForm()
  return (
    <FleLayout>
      <Form onSubmit={handleSubmit(submitPartnerName)}>
        <TopSection progressStep={3} leftOrBackArrow={<BackArrow />} />
        <SwitchH2ToBodyLarge>{`What's your partner's name?`}</SwitchH2ToBodyLarge>
        <Spacer height={2} />
        <CompleteFormInput
          name={"partnerFirstName"}
          label={"Partner's first name"}
          defaultValue={partnerFirstName}
          errors={errors}
          ref={register}
        />
        <CompleteFormInput
          name={"partnerLastName"}
          label={"Partner's last name"}
          defaultValue={partnerLastName}
          errors={errors}
          ref={register}
        />
      </Form>
      <FleLinkWrapper>
        <ContinueArrow onClick={handleSubmit(submitPartnerName)} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { AboutYourPartnerName }
